var _rect, _path, _path2, _circle, _circle2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.506836,
    width: 44.0663,
    height: 44.0663,
    rx: 22.0331,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4504 20.9997C25.4331 20.9997 27.8506 18.5377 27.8506 15.4999C27.8506 12.4621 25.4331 10 22.4504 10C19.4676 10 17.0502 12.4621 17.0502 15.4999C17.0502 18.5377 19.4676 20.9997 22.4504 20.9997ZM26.2305 22.3747H25.526C24.5894 22.813 23.5473 23.0622 22.4504 23.0622C21.3535 23.0622 20.3156 22.813 19.3748 22.3747H18.6702C15.5398 22.3747 13 24.9614 13 28.1496V29.937C13 31.0757 13.9071 31.9995 15.0251 31.9995H26.6229C26.5216 31.7073 26.4794 31.3979 26.5132 31.0843L25.42 29.2488L25.526 27.5989L27.58 24.8491H30.82C29.7864 23.6589 27.9139 22.3747 26.2305 22.3747Z",
    fill: "#005CEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 33C28.8775 33 28.2925 32.8819 27.745 32.6456C27.1975 32.4094 26.7213 32.0888 26.3163 31.6838C25.9113 31.2788 25.5906 30.8025 25.3544 30.255C25.1181 29.7075 25 29.1225 25 28.5C25 27.8775 25.1181 27.2925 25.3544 26.745C25.5906 26.1975 25.9113 25.7213 26.3163 25.3163C26.7213 24.9113 27.1975 24.5906 27.745 24.3544C28.2925 24.1181 28.8775 24 29.5 24C30.1225 24 30.7075 24.1181 31.255 24.3544C31.8025 24.5906 32.2788 24.9113 32.6838 25.3163C33.0888 25.7213 33.4094 26.1975 33.6456 26.745C33.8819 27.2925 34 27.8775 34 28.5C34 29.1225 33.8819 29.7075 33.6456 30.255C33.4094 30.8025 33.0888 31.2788 32.6838 31.6838C32.2788 32.0888 31.8025 32.4094 31.255 32.6456C30.7075 32.8819 30.1225 33 29.5 33ZM29.5 32.1C30.505 32.1 31.3563 31.7513 32.0538 31.0538C32.7513 30.3563 33.1 29.505 33.1 28.5C33.1 27.495 32.7513 26.6438 32.0538 25.9463C31.3563 25.2488 30.505 24.9 29.5 24.9C28.495 24.9 27.6438 25.2488 26.9463 25.9463C26.2488 26.6438 25.9 27.495 25.9 28.5C25.9 29.505 26.2488 30.3563 26.9463 31.0538C27.6438 31.7513 28.495 32.1 29.5 32.1Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 28.5,
    r: 6.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 28.5,
    r: 5.5,
    fill: "#005CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26L30.5 31",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28.5H33",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCreate);
export default __webpack_public_path__ + "static/media/b_create.f7f781867bbe084ec68844cbb0abf596.svg";
export { ForwardRef as ReactComponent };